import React from 'react';
import { Tooltip } from '@zvuk-b2b/ui-kit';
import { TEXTS } from '../../../texts';
import type { DurationEditHintProps } from './types';

const DurationEditHint: React.FC<DurationEditHintProps> = ({ isBlocked, children }) => (
  <Tooltip
    asChild
    placement="top-start"
    sideOffset={10}
    isDisabled={!isBlocked}
    content={TEXTS.BLOCK_EDIT_WARNING}>
    {/* Disabled inputs cannot receive focus; their tooltip needs this keyboard-accessible wrapper. */}
    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
    <div tabIndex={isBlocked ? 0 : undefined}>{children}</div>
  </Tooltip>
);

export default DurationEditHint;
